module.exports = __webpack_public_path__ + "static/ChristineKwong-36425f701e7c3b7e0fe174b7d1660f60.jpg";